const moment = require('moment')

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getAllByRentingPreparation: state => renting_preparation_id => state.items.filter(item => item.renting_preparation && item.renting_preparation.id == renting_preparation_id)
  },
  actions: {

    /**
     * Charge tous les commentaire d'une préparation via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   int     renting_preparation_id  Id de la préparation
     * @param   boolean wait                    Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns promise                         Aucune donnée n'est retournée
     */
    getAllByRentingPreparation: (context, {renting_preparation_id, wait = false}) => {
      let params = {
        wait: wait,
        api_url: 'rentingpreparationcomment/'+ renting_preparation_id,
        api_data_path: 'rentingPreparationComments',
        namespace: 'renting_preparation_comment'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    addItem(context, item) {
      let params = {
        api_url: 'rentingpreparationcomment',
        namespace: 'renting_preparation_comment',
        item: item
      }
      return context.dispatch('addItem', params, {
        root: true
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/renting_preparation_comment.js